/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Stats_SubtitleInputs */

const vi_lot_stats_subtitle = /** @type {(inputs: Lot_Stats_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê nhập/xuất + kiểm kê chốt sổ`)
};

/**

* @param {Lot_Stats_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_stats_subtitle = /** @type {((inputs?: Lot_Stats_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Stats_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_stats_subtitle(inputs)
});